// workspace-week.ts — Libellé du lundi d'une semaine de la tuile « charge ».
//
// Pur, donc testable : la tuile affiche « S36 », qui ne dit rien à qui ne
// compte pas les semaines de tête. L'infobulle donne la date d'ouverture de la
// semaine, et c'est cette conversion-là qui doit être vérifiée — un décalage
// d'un jour à l'est (le piège de `toISOString()`) donnerait un dimanche.

/**
 * `2026-08-31` → `31/08/26`.
 *
 * Construit à partir des composants de la chaîne ISO, sans passer par `Date` :
 * une date sans heure interprétée en UTC puis relue en heure locale recule
 * d'un jour à l'ouest de Greenwich. Ici le lundi doit rester un lundi.
 *
 * Retourne la chaîne d'entrée si elle n'a pas la forme attendue — une
 * infobulle dégradée vaut mieux qu'un « NaN/NaN/NaN ».
 */
export function mondayDmy(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
  if (!m) return iso || '';
  const [, year, month, day] = m;
  return `${day}/${month}/${(year as string).slice(2)}`;
}
